import React from 'react';
import { useSelector } from 'react-redux';

import { components } from '../components';
import { TabScreens } from '../routes';
import { RootState } from '../store';

import { PointLogScreen } from '../screens/PointLogScreen';
import { Home } from '../screens/tabs/Home';
import { Menu } from '../screens/tabs/Menu';
import { Order } from '../screens/Order';

export const TabNavigator: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen
  );

  const renderTitle = (): string => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return '';
      case TabScreens.Menu:
        return '';
      case TabScreens.Order:
        return '';
      case TabScreens.User:
        return '';
      default:
        return '';
    }
  };

  const renderScreens = (): JSX.Element | null => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return <Home />;
      case TabScreens.Menu:
        return <Menu />;
      case TabScreens.Order:
        return <Order />;
      default:
        return <Home />;
    }
  };

  const renderUserPhoto = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      default:
        return false;
    }
  };

  const renderUserName = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      default:
        return false;
    }
  };

  const renderSite = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.Order:
        return true;
      default:
        return false;
    }
  };

  const renderUserPoints = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.Order:
        return true;
      case TabScreens.User:
        return true;
      default:
        return false;
    }
  };

  const renderUser = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      default:
        return false;
    }
  };

  const renderLogo = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.Order:
        return true;
      default:
        return true;
    }
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showBasket={true}
        title={renderTitle()}
        userPoints={renderUserPoints()}
        userRender={renderUser()}
        leftLogo={renderLogo()}
        // userName={renderUserName()}
        userPhoto={renderUserPhoto()}
        siteRender={renderSite()}
      />
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <>
      {renderHeader()}
      {renderScreens()}
      {renderFooter()}
    </>
  );
};
